import { borderBottom } from "@material-ui/system";

/* Response Time CSS */

export default theme => ({
    rootClassName:{
        width:"100%"
    },
    calendarModal:{
        width:"50%"
    },
        calendarFont:{
            "& .WeekCalendar":{fontFamily:'Roboto'}
    
    }
});

